import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Estrategia from "../pages/estrategia/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/estrategia",
    element: <Estrategia />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
